import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  TRANSLATION_GROUP_NEW_APP_VERSION,
} from './constants';
import { getTranslationKeys } from './translations';

export class NewAppVersionModule extends AppModule {
  addRoutes(): void {}

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_NEW_APP_VERSION, getTranslationKeys);
  }
}
